import { render, staticRenderFns } from "./batch-error.vue?vue&type=template&id=7150be40&"
import script from "./batch-error.vue?vue&type=script&lang=js&"
export * from "./batch-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports